<template>
    <main class="expense-edit-page">
        <section class="expense-edit-card" v-loading="loading">
            <header class="expense-edit-header">
                <div class="expense-edit-title">
                    <el-button class="expense-back-button" icon="el-icon-arrow-left"
                               :aria-label="$t('common.back')"
                               @click.native.prevent="goBack"></el-button>
                    <h1>{{$t('updateExpense.title')}}</h1>
                </div>
                <div class="expense-edit-actions">
                    <el-button class="expense-delete-button" @click.native.prevent="openDeleteInvoiceDialog"
                               type="danger" plain :disabled="!expenseLoaded || loading">{{$t('updateExpense.deleteExpense')}}</el-button>
                    <el-button class="expense-save-button" type="primary" :disabled="!expenseLoaded || buttonDisabledStatus || saveRequestPending"
                               :loading="saveRequestPending"
                               @click.native.prevent="createExpense(0)">{{$t('common.saveAndClose')}}</el-button>
                </div>
            </header>

            <el-alert v-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
            <el-form v-else-if="expenseLoaded" class="expense-modern-form" label-width="0px">
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.description')}}</span>
                    <el-input class="expense-line-textarea" type="textarea" :autosize="{minRows: 1}"
                              v-model="expense.expenseDescription"

                              :placeholder="$t('createExpense.expenseDescriptionPlaceholder')"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.total')}}</span>
                    <el-input class="expense-line-input" inputmode="decimal"
                              :placeholder="$t('createExpense.total')"
                              v-model="expense.total"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.tax')}}</span>
                    <el-input class="expense-line-input" inputmode="decimal"
                              :placeholder="$t('createExpense.tax')"
                              v-model="expense.tax"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.tip')}}</span>
                    <el-input class="expense-line-input" inputmode="decimal"
                              :placeholder="$t('createExpense.tip')"
                              v-model="expense.tip"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.expenseDate')}}</span>
                    <el-date-picker class="expense-line-date" :editable=false type="date"
                                    :placeholder="$t('createExpense.expenseDate')"
                                    format="MMM dd, yyyy" v-model="expense.expenseDate" :clearable=false></el-date-picker>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">{{$t('createExpense.merchant')}}</span>
                    <el-input class="expense-line-input" v-model="expense.merchant"
                              :placeholder="$t('createExpense.merchantPlaceholder')"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row expense-category-row">
                    <span class="expense-form-label">{{$t('common.category')}}</span>
                    <div class="expense-category-control">
                        <el-select class="expense-line-select" v-model="expense.categoryUUID" :placeholder="$t('createExpense.categoryPlaceholder')">
                            <el-option v-for="item in activeCategoryList"
                                       :key="item.innerUUID"
                                       :label="item.name"
                                       :value="item.innerUUID">
                            </el-option>
                        </el-select>
                        <el-button class="expense-add-category-button" type="text" @click="openCategoryDiagory">
                            <span class="expense-add-category-icon"><i class="el-icon-plus"></i></span>
                            <span>{{$t('createExpense.addNewCategory')}}</span>
                        </el-button>
                    </div>
                </el-form-item>

                <div class="expense-photo-list" v-if="activeFileList.length > 0">
                    <div class="expense-photo-card" v-for="file in activeFileList" :key="file.innerUUID">
                        <el-image class="expense-photo-preview" :src="file.url" fit="cover">
                            <div slot="placeholder" class="remote-image-loading">
                                <i class="el-icon-loading"></i>
                            </div>
                        </el-image>
                        <el-button class="expense-photo-delete" @click="handleRemove(file.innerUUID)" type="text">{{$t('createExpense.deletePhoto')}}</el-button>
                    </div>
                </div>

                <div class="expense-upload-row" v-if='activeFileList.length==0'>
                    <el-upload
                            :action=requestURL
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleUploadError"
                            :before-upload="onBeforeUpload"
                            :data="uploadData"
                            accept="image/jpeg,image/png,image/bmp">
                        <el-button class="expense-upload-button" :loading="attachPhotosStatus">
                            <span class="expense-upload-icon"><i class="el-icon-paperclip"></i></span>
                            <span class="expense-upload-text">
                                <strong>{{$t('createExpense.addPhoto')}}</strong>
                            </span>
                        </el-button>
                    </el-upload>
                </div>

                <el-dialog :title="$t('createExpense.addNewCategory')" :visible.sync="categoryDiagoryStatus" width="720px"
                           custom-class="expense-category-dialog">
                            <div class="expense-category-dialog-list">
                                <template v-for="item in categoryList">
                                <div class="expense-category-dialog-row" :key="item.innerUUID" v-if="item.syncStatus!=1">
                                    <span v-if="item.isNew!=1" class="expense-category-dialog-name">{{ item.name }}</span>
                                    <el-input v-else class="expense-category-dialog-input" v-model="item.name"
></el-input>
                                    <el-button v-if="item.isNew!=1" class="expense-category-dialog-delete" type="text"
                                               @click="deleteCategory(item.innerUUID,item.isNew)">{{$t('createExpense.deleteCategory')}}</el-button>
                                    <el-button v-else class="expense-category-dialog-delete" type="text"
                                               @click="deleteCategory(item.innerUUID,1)">{{$t('createExpense.deleteCategory')}}</el-button>
                                </div>
                                </template>
                            </div>
                            <el-button class="expense-category-dialog-add" type="text" @click="addCategory()">
                                <span class="expense-category-dialog-add-icon"><i class="el-icon-plus"></i></span>
                                <span>{{$t('createExpense.addCategory')}}</span>
                            </el-button>
                            <div slot="footer" class="dialog-footer">
                                <el-button class="expense-category-dialog-close" @click="categoryDiagoryStatus=false">{{$t('common.close')}}</el-button>
                            </div>
                        </el-dialog>
            </el-form>
        </section>
    </main>
</template>

<script>
    import {uuid, timest, toTmpTime} from '@/utils/validate'
    import {
        isValidExpenseAmount,
        trimmedExpenseCategoryName
    } from '@/utils/expenseInputValidation'
    import {syncCompanySelection} from '@/utils/company'
    import {
        EXPENSE_IMAGES_FOLDER,
        getDownloadV2Url,
        getFileUploadUrl,
        getStoredImageDownloadUrl,
        getUploadRemoteKey,
        prepareFileUpload,
        takeUploadInnerUUID,
        discardPreparedFileUpload
    } from '@/utils/fileUpload'


    export default {
        data() {
            return {
                buttonDisabledStatus: true,
                expenseLoaded: false,
                loadError: "",
                saveRequestPending: false,
                expense: {
                    "expenseDate": new Date(),
                    "categoryUUID": ""
                },
                fileList: [],
                attachPhotosStatus: false,
                requestURL: "",
                uploadData: {
                    email: ""
                },
                uploadFileMap: {},
                company: null,
                loading: false,
                categoryList: [],
                categoryDiagoryStatus: false,
                newCategoryList: [],
                allowRouteLeave: false,
                initialSnapshot: ''
            }
        },
        computed: {
            activeFileList() {
                return this.fileList.filter(file => file.syncStatus != 1);
            },
            activeCategoryList() {
                return this.categoryList.filter(category => category.syncStatus != 1);
            }
        },

        methods: {
            showValidationError(messageKey) {
                this.$message.error(this.$t(messageKey));
            },
            validateExpense() {
                const amountFields = ['total', 'tax', 'tip'];
                for (let i = 0; i < amountFields.length; i++) {
                    const field = amountFields[i];
                    if (!isValidExpenseAmount(this.expense[field])) {
                        this.showValidationError('createExpense.amountInvalid');
                        return false;
                    }
                }
                for (let i = 0; i < this.categoryList.length; i++) {
                    const category = this.categoryList[i];
                    if (category.isNew == 1 && category.syncStatus != 1) {
                        const name = trimmedExpenseCategoryName(category.name);
                        if (name.length === 0) {
                            this.showValidationError('createExpense.categoryRequired');
                            return false;
                        }
                        category.name = name;
                    }
                }
                return true;
            },
            buildExpenseImageForRequest(fileInfo, expenseUUID, syncStatus) {
                if (fileInfo.originExpenseImage != null) {
                    let expenseImage = JSON.parse(JSON.stringify(fileInfo.originExpenseImage));
                    expenseImage.syncStatus = syncStatus;
                    expenseImage.expenseUUID = expenseUUID;
                    expenseImage.accessDate = timest();
                    delete expenseImage.fromClient;
                    return expenseImage;
                }
                return {
                    accessDate: timest(),
                    createDate: timest(),
                    imageIsNew: 0,
                    imagePath: fileInfo.imagePath,
                    innerUUID: fileInfo.innerUUID,
                    companyUUID: this.company.innerUUID,
                    expenseUUID: expenseUUID,
                    syncStatus: syncStatus,
                    remoteKey: fileInfo.remoteKey,
                    transferStatusRaw: 1,
                    imageSchemaVersion: 1
                };
            },
            postExpense(updateOrDelete, expenseUUID, categoryList, companyLogo, expenseImageUUIDArrayKey) {
                return this.$axios.post('web_create_expense', {
                    params: {
                        "expense": {
                            accessDate: timest(),
                            createDate: timest(),
                            innerUUID: expenseUUID,
                            companyUUID: this.company.innerUUID,
                            expenseDate: toTmpTime(this.expense.expenseDate),
                            expenseDescription: this.expense.expenseDescription,
                            imageIsNew: 0,
                            imagePath: "",
                            merchant: this.expense.merchant,
                            tax: this.expense.tax,
                            tip: this.expense.tip,
                            total: this.expense.total,
                            categoryUUID: this.expense.categoryUUID,
                            expenseImageUUIDArrayKey: expenseImageUUIDArrayKey,
                            syncStatus: updateOrDelete,
                            fromClient: 3
                        },
                        "categoryList": categoryList,
                        companyLogo: companyLogo
                    }
                });
            },
            getDeletedExpenseImage() {
                for (let index = 0; index < this.fileList.length; index++) {
                    const file = this.fileList[index];
                    if (file.syncStatus == 1 && file.originExpenseImage != null) {
                        return file;
                    }
                }
                return null;
            },
            buildExpenseSaveSteps(updateOrDelete, expenseUUID) {
                const activeImage = this.activeFileList.length > 0 ? this.activeFileList[0] : null;
                const deletedImage = this.getDeletedExpenseImage();
                if (updateOrDelete == 1) {
                    const deleteImage = activeImage != null ? activeImage : deletedImage;
                    return [{
                        companyLogo: deleteImage == null
                            ? null
                            : this.buildExpenseImageForRequest(deleteImage, expenseUUID, 1),
                        expenseImageUUIDArrayKey: "",
                        includeCategories: true
                    }];
                }

                const steps = [];
                if (deletedImage != null) {
                    steps.push({
                        companyLogo: this.buildExpenseImageForRequest(deletedImage, expenseUUID, 1),
                        expenseImageUUIDArrayKey: "",
                        includeCategories: false
                    });
                }
                if (activeImage != null) {
                    steps.push({
                        companyLogo: this.buildExpenseImageForRequest(activeImage, expenseUUID, 0),
                        expenseImageUUIDArrayKey: activeImage.innerUUID,
                        includeCategories: true
                    });
                }
                if (steps.length === 0) {
                    steps.push({
                        companyLogo: null,
                        expenseImageUUIDArrayKey: "",
                        includeCategories: true
                    });
                } else {
                    steps[steps.length - 1].includeCategories = true;
                }
                return steps;
            },
            saveExpense(updateOrDelete, expenseUUID, createCategoryList, afterSave) {
                const steps = this.buildExpenseSaveSteps(updateOrDelete, expenseUUID);
                let request = Promise.resolve();
                steps.forEach(step => {
                    request = request.then(() => this.postExpense(
                        updateOrDelete,
                        expenseUUID,
                        step.includeCategories ? createCategoryList : [],
                        step.companyLogo,
                        step.expenseImageUUIDArrayKey
                    )).then(response => {
                        if (response.data.errorCode !== 0) {
                            throw new Error('Expense save failed');
                        }
                    });
                });
                return request.then(() => {
                    this.allowRouteLeave = true;
                    if (typeof afterSave === 'function') {
                        afterSave();
                    } else {
                        this.$router.push('/expense');
                    }
                }).catch(() => {
                    this.$message.error(this.$t(updateOrDelete === 1 ? 'common.deleteFailed' : 'common.saveFailed'));
                }).finally(() => {
                    this.loading = false;
                    this.buttonDisabledStatus = false;
                    this.saveRequestPending = false;
                });
            },
            openCategoryDiagory() {
                this.categoryDiagoryStatus = true;
            },
            goBack() {
                let self = this;
                self.$router.push('/expense');
            },
            addCategory() {
                let newObj = {
                    "name": "",
                    "innerUUID": uuid(null, 37),
                    "syncStatus": 0,
                    "isNew": 1,
                    "companyUUID": this.company.innerUUID
                };
                this.categoryList.push(newObj);
            },
            deleteCategory(innerUUID, oldOrNew) {
                if (oldOrNew == 0 || oldOrNew == undefined) {
                    for (let i = 0; i < this.categoryList.length; i++) {
                        if (this.categoryList[i].innerUUID == innerUUID) {
                            this.categoryList[i].syncStatus = 1;
                            if (this.expense.categoryUUID === innerUUID) {
                                this.expense.categoryUUID = '';
                            }
                            break;
                        }
                    }
                } else if (oldOrNew == 1) {
                    for (let i = 0; i < this.categoryList.length; i++) {
                        if (this.categoryList[i].innerUUID == innerUUID) {
                            this.categoryList.splice(i--, 1);
                            break;
                        }
                    }
                }
            },
            //打开删除框
            openDeleteInvoiceDialog() {
                if (!this.expenseLoaded || this.loading) {
                    return;
                }
                this.$confirm(this.$t('updateExpense.confirmDeleteMsg'), this.$t('common.warning'), {
                    confirmButtonText: this.$t('common.ok'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: 'warning'
                }).then(() => {
                    this.deleteInvoice();
                }).catch(() => {});
            },
            deleteInvoice() {
                this.createExpense(1);
            },
            //0:update,1.delete
            createExpense(updateOrDelete, afterSave) {
                if (!this.expenseLoaded || this.loading || this.saveRequestPending || this.company == null
                    || this.expense.companyUUID !== this.company.innerUUID) {
                    return;
                }
                if (updateOrDelete === 0 && !this.validateExpense()) {
                    return;
                }
                this.saveRequestPending = true;
                let that = this;
                this.loading = true;
                this.buttonDisabledStatus = true;

                let createCategoryList = [];
                for (let i = 0; i < this.categoryList.length; i++) {
                    let category = this.categoryList[i];
                    //删除的category
                    if (category.syncStatus == 1) {
                        let needCreateCategory = {
                            accessDate: timest(),
                            createDate: timest(),
                            innerUUID: category.innerUUID,
                            isDelete: 0,
                            name: category.name,
                            syncStatus: 1,
                            fromClient: 3,
                            companyUUID: this.company.innerUUID
                        };
                        createCategoryList.push(needCreateCategory);
                    }

                    if (category.isNew == 1) {
                        let needCreateCategory = {
                            accessDate: timest(),
                            createDate: timest(),
                            innerUUID: category.innerUUID,
                            isDelete: 0,
                            name: category.name,
                            syncStatus: 0,
                            fromClient: 3,
                            companyUUID: this.company.innerUUID
                        };
                        createCategoryList.push(needCreateCategory);
                    }
                }

                return this.saveExpense(updateOrDelete, that.expense.innerUUID, createCategoryList, afterSave);
            },

            queryExpense() {
                this.loading = true;
                this.expenseLoaded = false;
                this.loadError = "";
                this.buttonDisabledStatus = true;
                this.fileList = [];
                let that = this;
                return this.$axios.post('query_expense_for_web', {
                    params: {
                        "innerUUID": this.$route.query.innerUUID,
                        "companyUUID": this.company.innerUUID
                    }
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error('Expense query failed');
                    }
                    if (response.data.objectData == null) {
                        throw new Error('Expense response is incomplete');
                    }
                    if ((response.data.objectData.innerUUID != null
                            && response.data.objectData.innerUUID !== this.$route.query.innerUUID)
                        || (response.data.objectData.companyUUID != null
                            && response.data.objectData.companyUUID !== this.company.innerUUID)) {
                        throw new Error('Expense response is incomplete');
                    }
                    const sourceCategories = Array.isArray(response.data.categoryForWebList)
                        ? response.data.categoryForWebList : [];
                    let categoryList = JSON.parse(JSON.stringify(sourceCategories));
                    this.categoryList = [];
                    for (let i = 0; i < categoryList.length; i++) {
                        let category = categoryList[i];
                        if (category != null
                            && (category.companyUUID == null || category.companyUUID === this.company.innerUUID)
                            && Number(category.syncStatus) !== 1) {
                            this.categoryList.push(category);
                        }
                    }

                    that.expense = JSON.parse(JSON.stringify(response.data.objectData));
                    const expenseDate = Number(that.expense.expenseDate == null ? 0 : that.expense.expenseDate);
                    that.expense.expenseDate = new Date(expenseDate * 1000);

                    let expenseImage = response.data.expenseImageForWeb;
                    if (null != expenseImage) {
                        if (expenseImage.companyUUID !== this.company.innerUUID
                            || expenseImage.expenseUUID !== that.expense.innerUUID) {
                            expenseImage = null;
                        }
                    }
                    if (null != expenseImage) {
                        let tempImage = {
                            innerUUID: expenseImage.innerUUID,
                            imagePath: expenseImage.imagePath,
                            remoteKey: expenseImage.remoteKey,
                            name: expenseImage.innerUUID,
                            url: getStoredImageDownloadUrl(this.$store.state.requestURL, expenseImage),
                            syncStatus: expenseImage.syncStatus,
                            originExpenseImage: JSON.parse(JSON.stringify(expenseImage))
                        };
                        this.fileList.push(tempImage)
                    }

                    that.loading = false;
                    that.expenseLoaded = true;
                    that.buttonDisabledStatus = false;
                    that.initialSnapshot = that.expenseSnapshot();
                }).catch(function () {
                    that.loading = false;
                    that.expenseLoaded = false;
                    that.buttonDisabledStatus = true;
                    that.loadError = that.$t('common.loadFailed');
                })
            },
            async loadPage() {
                this.loading = true;
                this.expenseLoaded = false;
                this.loadError = '';
                this.buttonDisabledStatus = true;
                try {
                    const response = await this.$axios.post('query_setting_and_company', {params: {}});
                    if (response.data.errorCode !== 0) {
                        throw new Error('Company and setting query failed');
                    }
                    const selectedData = syncCompanySelection(response.data);
                    if (selectedData == null) {
                        throw new Error('Selected company data is missing');
                    }
                    this.company = selectedData.company;
                    await this.queryExpense();
                } catch {
                    this.loading = false;
                    this.expenseLoaded = false;
                    this.buttonDisabledStatus = true;
                    this.loadError = this.$t('common.loadFailed');
                }
            },
            ///////////////上传///////////////
            handleRemove(fileName) {
                for (let i = 0; i < this.fileList.length; i++) {
                    if (this.fileList[i].innerUUID === fileName) {
                        if (this.fileList[i].originExpenseImage != null) {
                            this.fileList[i].syncStatus = 1;
                        } else {
                            this.fileList.splice(i--, 1);
                        }
                    }
                }
            },
            onBeforeUpload(file) {
                prepareFileUpload(this.uploadData, this.uploadFileMap, file, EXPENSE_IMAGES_FOLDER);
                this.attachPhotosStatus = true;
                return true;
            },
            handlePictureCardPreview() {

            },
            handleUploadError(error, file) {
                discardPreparedFileUpload(this.uploadFileMap, file);
                this.attachPhotosStatus = false;
                this.$message.error(this.$t('createExpense.photoUploadFailed'));
            },
            handleSuccess(res, file) {
                this.attachPhotosStatus = false;
                if (res != null && res.errorCode === 0 && Array.isArray(res.uploadFileList)
                    && res.uploadFileList.length === 1) {
                    this.$message({
                        type: 'info',
                        message: this.$t('common.uploadSuccess'),
                        duration: 6000
                    });
                    const innerUUID = takeUploadInnerUUID(this.uploadFileMap, file);
                    const remoteKey = getUploadRemoteKey(EXPENSE_IMAGES_FOLDER, innerUUID);
                    let fileInfo = {
                        url: getDownloadV2Url(this.$store.state.requestURL, remoteKey),
                        innerUUID: innerUUID,
                        imagePath: innerUUID + ".jpg",
                        remoteKey: remoteKey,
                        syncStatus: 0
                    };
                    this.fileList.push(fileInfo);
                } else {
                    discardPreparedFileUpload(this.uploadFileMap, file);
                    this.$message.error(this.$t('createExpense.photoUploadFailed'));
                }
            },
            expenseSnapshot() {
                if (!this.expenseLoaded) {
                    return '';
                }
                return JSON.stringify({
                    expenseDate: this.expense.expenseDate instanceof Date ? this.expense.expenseDate.getTime() : null,
                    expenseDescription: this.expense.expenseDescription,
                    merchant: this.expense.merchant,
                    tax: String(this.expense.tax),
                    tip: String(this.expense.tip),
                    total: String(this.expense.total),
                    categoryUUID: this.expense.categoryUUID,
                    categories: this.categoryList.map(category => ({
                        innerUUID: category.innerUUID,
                        name: category.name,
                        syncStatus: category.syncStatus,
                        isNew: category.isNew == null ? null : category.isNew
                    })),
                    images: this.fileList.map(file => ({
                        innerUUID: file.innerUUID,
                        imagePath: file.imagePath,
                        remoteKey: file.remoteKey,
                        syncStatus: file.syncStatus
                    }))
                });
            },
            hasUnsavedChanges() {
                return this.initialSnapshot !== '' && this.expenseSnapshot() !== this.initialSnapshot;
            },
            ///////////////上传///////////////

        },
        beforeRouteLeave(to, from, next) {
            if (this.allowRouteLeave || !this.hasUnsavedChanges()) {
                next();
                return;
            }
            this.$confirm(this.$t('common.unsavedChangesMsg'), this.$t('common.saveChangesTitle'), {
                confirmButtonText: this.$t('common.confirmSave'),
                cancelButtonText: this.$t('common.discard'),
                type: 'warning',
                distinguishCancelAndClose: true,
                closeOnClickModal: false,
                closeOnPressEscape: false
            }).then(() => {
                this.createExpense(0, next);
            }).catch(action => {
                if (action === 'cancel') {
                    this.allowRouteLeave = true;
                    next();
                } else {
                    next(false);
                }
            });
        },
        mounted() {
            this.requestURL = getFileUploadUrl(this.$store.state.requestURL);
            this.uploadData.email = JSON.parse(localStorage.getItem("loginInformation")).objectData.email;
            this.loadPage();
        }
    }
</script>
